import { Component, OnInit, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { BaseComponent } from 'src/app/core/abstracts/base.component';
import { ResultModel } from 'src/app/core/models/result.model';
import { PasswordModel } from 'src/app/core/models/password.model';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-change-password',
    template: `
        <div class="row">
            <div class="col-md-11 center" style="text-align: unset;">
                <h4 class="mb-5 text-center form-text-heading2"><i class="fas fa-key form-icon-heading" aria-hidden="true"></i>Şifre Belirle</h4>
                
                <form class="needs-validation" name="form" (ngSubmit)="f.form.valid && changePasswordModel()" #f="ngForm"
                novalidate>
                    

                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <label class="form-text" for="txt_form_ChangePassword_CurrentPassword">Mevcut Şifreniz <span class="required"></span></label>
                            <input autocomplete="off"  type="password" class="form-control" id="txt_form_ChangePassword_CurrentPassword" name="txt_form_ChangePassword_CurrentPassword" placeholder="Mevcut şifre"
                                [(ngModel)]="model.CurrentPassword"   #CurrentPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && CurrentPassword.invalid }" required>
                            <div *ngIf="f.submitted && CurrentPassword.invalid" class="invalid-feedback">
                                <div *ngIf="CurrentPassword.errors.required">Mevcut Şifre zorunlu.</div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <label class="form-text" for="txt_form_ChangePassword_NewPassword">Yeni Şifreniz <span class="required"></span></label>
                            <input autocomplete="off"  type="password" class="form-control" id="txt_form_ChangePassword_NewPassword" name="txt_form_ChangePassword_NewPassword" placeholder="Yeni Şifre"
                                [(ngModel)]="model.Password" #Password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && Password.invalid }" required>
                                <div *ngIf="f.submitted && Password.invalid" class="invalid-feedback">
                                    <div *ngIf="Password.errors.required">Yeni Şifre zorunlu.</div>
                                </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <label class="form-text" for="txt_form_ChangePassword_NewPasswordConfirm">Yeni Şifreniz Tekrar <span class="required"></span></label>
                            <input autocomplete="off"  type="password" class="form-control" id="txt_form_ChangePassword_NewPasswordConfirm"
                            name="txt_form_ChangePassword_NewPasswordConfirm" placeholder="Yeni Şifre Tekrar"
                                [(ngModel)]="model.PasswordConfirm"  #PasswordConfirm="ngModel" [ngClass]="{ 'is-invalid': f.submitted && PasswordConfirm.invalid }" required>
                                <div *ngIf="f.submitted && PasswordConfirm.invalid" class="invalid-feedback">
                                    <div *ngIf="PasswordConfirm.errors.required">Yeni Şifre zorunlu.</div>
                                </div>
                                <div class="col-md-12 mt-3 alert alert-danger" role="alert"   *ngIf="passwordequalsconfirm == true">Şifre Eşleşmiyor</div>
                        </div>
                        
                    </div>
                    <div class="center tablo-button">
                    <button *ngIf="!model.ForceChangePassword" type="button" class="btn tablo-edit-button" (click)="cancel()">Kapat</button>
                    <button type="submit" class="btn tablo-new tablo-new-button">Kaydet</button>
                </div>
                    
                </form>

            </div>
        </div>
    `,
    styleUrls: []
})
export class ChangePasswordComponent extends BaseComponent implements OnInit {

    model: PasswordModel = new PasswordModel;

    passwordequalsconfirm: boolean = false;
    dd: any

    @ViewChild(NgForm)
    f: NgForm;

    ngOnInit() {
        this.model.ForceChangePassword = this.authService.shouldForceChangePassword();
    }

    cancel() {
        this.resetModel();
        this.onCancel.emit(new ResultModel(false, 'İptal edildi'));
    }



    changePasswordModel() {

        if (this.model.Password == this.model.PasswordConfirm) {

            this.passwordService.changePassword(this.model)
                .subscribe(result => {
                    if (result.Success) {
                        if (this.model.ForceChangePassword){
                            this.authService.toggleForceChangePassword("");
                        }
                        this.resetModel();
                        this.onResult.emit(new ResultModel(true, 'Parola başarılı bir şekilde değiştirildi'));
                    }
                    else {
                        this.onResult.emit(result);
                    }
                },
                    error => {
                        this.onResult.emit(new ResultModel(false, 'Parola değiştirilirken hata meydana geldi'));
                    }
                );
        } else {
            this.passwordequalsconfirm = true;
            setTimeout(() => {
                this.passwordequalsconfirm = false;
            }, 2000);

        }


    }

    resetModel() {
        this.f.resetForm();
        setTimeout(() => {
            this.model = new PasswordModel;
        }, 0);


    }

}
